import { isFeatureEnabled } from 'store/abTesting/helpers';
import { isAuthenticatedSelector } from 'store/auth/selectors';
import { selectCurrentUser } from 'store/user/selectors';

import { START_FINISH_TEST } from 'constants/features';
import { PATHS } from 'constants/routerPaths';

import { useSelector } from 'hooks';

export const useGetRedirectPath = () => {
    const isAuthenticated = useSelector(isAuthenticatedSelector);
    const isStartWorkoutFeatureEnabled = isFeatureEnabled(START_FINISH_TEST);
    const { is_logged_in, user_workout_info } = useSelector(selectCurrentUser);
    const isExperiment = isStartWorkoutFeatureEnabled && is_logged_in;
    const finishFirstWorkout = user_workout_info?.finish_first_workout;
    const startFirstWorkout = user_workout_info?.start_first_workout;

    if (!isStartWorkoutFeatureEnabled && !isAuthenticated) return PATHS.TEMPORARY_PASSWORD;
    if (isExperiment && !finishFirstWorkout && !startFirstWorkout) return PATHS.START_WORKOUT_PAGE;
    if (isExperiment && startFirstWorkout && !finishFirstWorkout) return PATHS.FINISH_WORKOUT_PAGE;
    if (isExperiment && finishFirstWorkout) return PATHS.CONTINUE_PROGRESS_PAGE;

    return PATHS.MAIN;
};
